import { httpService as r } from "@waitroom/http-client";
import { buildApiParams as t } from "../helpers.es.js";
const n = {
  getPlans: async (i) => r.get(
    await t("/billing/plans", {
      ...i,
      version: "v2.0"
    })
  )
};
export {
  n as subscriptionPlanApiService
};
